// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see SyncEntitySyncWipeEvent
 */
export var SyncEntitySyncWipe = function (_a) {
    var reason = _a.reason, countRangesDeleted = _a.countRangesDeleted, countEntitiesDeleted = _a.countEntitiesDeleted;
    return ({
        name: "SyncEntity Sync Wipe",
        parameters: {
            cdf_entity: "SyncEntity",
            cdf_action: "Sync",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            count_ranges_deleted: countRangesDeleted !== undefined && countRangesDeleted !== null ? countRangesDeleted.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            count_entities_deleted: countEntitiesDeleted !== undefined && countEntitiesDeleted !== null ? countEntitiesDeleted.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SyncEntitySyncCompleteEvent
 */
export var SyncEntitySyncComplete = function (_a) {
    var elapsedTimeMs = _a.elapsedTimeMs, isFreshSync = _a.isFreshSync;
    return ({
        name: "SyncEntity Sync Complete",
        parameters: {
            cdf_entity: "SyncEntity",
            cdf_action: "Sync",
            elapsed_time_ms: elapsedTimeMs !== undefined && elapsedTimeMs !== null ? elapsedTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_fresh_sync: isFreshSync !== undefined && isFreshSync !== null ? isFreshSync.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SyncEntityUpdateStaleEntityEvent
 */
export var SyncEntityUpdateStaleEntity = function (_a) {
    var entityId = _a.entityId, currVersion = _a.currVersion, newVersion = _a.newVersion, versionElapsedTimeDiffMs = _a.versionElapsedTimeDiffMs, entityType = _a.entityType;
    return ({
        name: "SyncEntity Update StaleEntity",
        parameters: {
            cdf_entity: "SyncEntity",
            cdf_action: "Update",
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            curr_version: currVersion !== undefined && currVersion !== null ? currVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_version: newVersion !== undefined && newVersion !== null ? newVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            version_elapsed_time_diff_ms: versionElapsedTimeDiffMs !== undefined && versionElapsedTimeDiffMs !== null ? versionElapsedTimeDiffMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_type: entityType !== undefined && entityType !== null ? entityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SyncEntityUpdateMigrationStatusReportEvent
 */
export var SyncEntityUpdateMigrationStatusReport = function (_a) {
    var migratedSyncValues = _a.migratedSyncValues;
    return ({
        name: "SyncEntity UpdateMigrationStatus Report",
        parameters: {
            cdf_entity: "SyncEntity",
            cdf_action: "UpdateMigrationStatus",
            migrated_sync_values: migratedSyncValues !== undefined && migratedSyncValues !== null ? migratedSyncValues.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
